import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_OUR_WORK_ERROR, GET_OUR_WORK_START, GET_OUR_WORK_SUCCESS } from '../../types';

import apiCall from '../../../api/apiGet';

export function* get({ payload }) {
  try {
    const url = payload.lang ? `/our-work/${payload.lang}` : '/our-work/';
    const method = 'GET';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: GET_OUR_WORK_SUCCESS, results: results.data });

  } catch (error) {
    console.log(error)
    yield put({ type: GET_OUR_WORK_ERROR, error });
  }
}

export default function* get_our_work() {
  yield takeLatest(GET_OUR_WORK_START, get);
}

